<span *ngIf="role === rolesEnum.Witness">getuige</span>
<span *ngIf="role === rolesEnum.CounterParty">tegenpartij</span>
<span *ngIf="role === rolesEnum.Driver">bestuurder</span>
<span *ngIf="role === rolesEnum.CoInsured">medeverzekerde</span>
<span *ngIf="role === rolesEnum.Contact">afwijkende contactpersoon</span>
